document.addEventListener('DOMContentLoaded', function () {

  var guideSwiper;
  var root = document.getElementById('guide-local-menu-wrp');

  if (!root) return;

  var el = root.querySelector('.swiper');

  if (!el) return;

  /**
   * Swiperを有効化
   */
  function initializeSwiper() {
    if (guideSwiper && !guideSwiper.destroyed) return;

    guideSwiper = new Swiper('#guide-local-menu-wrp .swiper', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      freeMode: true,

      scrollbar: {
        el: '#guide-local-menu-wrp .swiper-scrollbar',
        hide: false,
        draggable: true
      },

      mousewheel: {
        forceToAxis: true
      },

      grabCursor: true
    });
  }

  /**
   * Swiperを解除
   */
  function destroySwiper() {
    if (guideSwiper && !guideSwiper.destroyed) {
      guideSwiper.destroy(true, true);
    }

    guideSwiper = null;
  }

  /**
   * 画面幅に応じてSwiperを切り替え
   */
  function handleResize() {
    var width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (width > 768) {
      initializeSwiper();
    } else {
      destroySwiper();
    }
  }

  handleResize();

  window.addEventListener('resize', handleResize);
});